import { observer } from 'mobx-react-lite'
import { ExistingRoomState } from './ExistingRoomState'
import { Dialog } from 'components/dialogs/Dialog'
import { DialogCloseButton } from 'components/dialogs/DialogCloseButton'
import type { StudentAssignmentCubit } from '@breakoutlearning/firebase-repository/cubits/StudentAssignmentCubit'
import { NewRoomStateV2 } from './NewRoomStateV2'
import { useId } from 'react'

export const RoomsDialog = observer(function RoomsModal({
  cubit,
  closeSelf,
}: {
  cubit: StudentAssignmentCubit
  /** Closes this dialog entry specifically. Joining a room changes the route,
   * which clears the dialog stack, so a bare `popDialog()` after the join's
   * async write can pop whatever dialog the user opened next instead. */
  closeSelf: () => void
}) {
  const headingId = useId()
  if (cubit.roomStateId) {
    return (
      <Dialog testId="rooms-dialog" size="sm" aria-labelledby={headingId}>
        <DialogCloseButton />
        <ExistingRoomState cubit={cubit} headingId={headingId} />
      </Dialog>
    )
  }

  return (
    <Dialog
      testId="rooms-dialog"
      size="xl"
      className="h-[750px] w-[1200px]"
      innerClassName="flex h-full mx-auto"
      aria-labelledby={headingId}
    >
      <DialogCloseButton />
      <NewRoomStateV2
        cubit={cubit}
        headingId={headingId}
        closeSelf={closeSelf}
      />
    </Dialog>
  )
})
